<template>
  <div v-if="show" class="loader-wrapper fixed inset-0 flex justify-center items-center z-50 bg-blue-900 bg-opacity-90">
    <div class="app-loader" />
  </div>
</template>

<script>
export default {
  props: ['show']
}
</script>

<style scoped>
.app-loader {
  position: relative;
  width: 4rem;
  height: 4rem;
  border: .25rem solid #3cefff;
  overflow: hidden;
  animation: spin 3s ease infinite;
}

.app-loader::before {
  content: '';
  position: absolute;
  top: -.25rem;
  left: -.25rem;
  width: 4rem;
  height: 4rem;
  background-color: hsla(185, 100%, 62%, 0.75);
  transform-origin: center bottom;
  transform: scaleY(1);
  animation: fill 3s linear infinite;
}

@keyframes spin {
  50%,
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fill {
  25%,
  50% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}
</style>